import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-timeline.title',
		defaultMessage: 'Your plan, visualized',
		description: 'The title for the spotlight',
	},
	content: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-timeline.content',
		defaultMessage:
			'Issue data such as dates and dependencies are displayed here, along with releases and other planning data.',
		description: 'The content for the spotlight',
	},
});
